import React, {useState} from "react";
import UI from "components/UI";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import CommonUtil from "utils/CommonUtil";
import ValidationUtil from "common/validation/util/ValidationUtil";
import TbCommCorpBizLic from "domain/main/comm/corp/biz/lic/TbCommCorpBizLic";
import UIFileDownload from "components/file/UIFileDownload";
import codeDataStore from "common/codedata/store/CodeDataStore";
import UIUtils from "utils/UIUtils";
import StringUtil from 'utils/StringUtil';
import DateUtil from "utils/DateUtil";
import UIDatePicker from "components/datepicker";
import UIInput from 'components/input/input';
import UISelect from 'components/selectbox/UISelect';
import message from "common/message/source/MessageSource";
import PageLoading from "../../../../components/loading";

function ContentsContainer() {
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();

	const [bizInfo, setBizInfo] = useState({});
	const [bizCd, setBizCd] = useState("");
	const [bizNm, setBizNm] = useState("");
	const [bizShortNm,setBizShortNm] = useState('')
	const [bizStDate,setBizStDate] = useState('')
	const [bisEnDate,setBizEnDate] = useState('')
	
	const [funPurUseCd,setFunPurUseCd] = useState('')
	const [funPurUseCdNm,setFunPurUseCdNm] = useState('')
	const [funPurUseNo,setFunPurUseNo] = useState('')
	const [funPurUseNoNm,setFunPurUseNoNm] = useState('')
	const [middCorpPermYn,setMiddCorpPermYn] = useState('')
	
	const [donReceIssContCd,setDonReceIssContCd] = useState('')
	const [bizMainMangUserid,setBizMainMangUserid] = useState('')
	const [bizMainMangUserNm,setBizMainMangUserNm] = useState('')
	const [bizDeptMangUserid,setBizDeptMangUserid] = useState('')
	const [bizDeptMangUserNm,setBizDeptMangUserNm] = useState('')
	
	const [notes,setNotes] = useState('')
	const [donReceIssKey,setDonReceIssKey] = useState('')
	const [regUserId,setRegUserId] = useState('');
	const [regUserNm,setRegUserNm] = useState('');
	const [modiUserId,setmodiUserId] = useState('');
	const [modiUserNm,setmodiUserNm] = useState('');
	const [regDate,setRegDate] = useState('');
	const [modiDate,setModiDate] = useState('');
	const [mode , setMode] = useState('');
	const [readOnly , setReadOnly] = useState(true);
	const [loadFinish,setLoadFinish] = useState(false);

	function dateLpad(num){
		let strNum = num;
		if(strNum.length == 1){
			strNum = "0"+strNum;
		}

		return strNum;
	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(String(month))+'-'+dateLpad(String(day))+'('+dayName+')';
	}
	

	async function initCall(bizCd){
		let param = {
			"BIZ_CD": bizCd
		};

		const response:any = await CommonUtil.execute({
			url:'adm_6311_detail',
			data: param
		})

		const result = response.REC;
		setBizInfo(result);

		setBizCd(result.BIZ_CD);
		setBizNm(result.BIZ_NM);
		setBizShortNm(result.BIZ_SHORT_NM);
		setBizStDate(dateToStr(result.BIZ_ST_DATE));
		setBizEnDate(dateToStr(result.BIS_EN_DATE));
		setFunPurUseCd(result.FUN_PUR_USE_CD);
		setFunPurUseCdNm(result.FUN_PUR_USE_CD_NM);
		setFunPurUseNo(result.FUN_PUR_USE_NO);
		setFunPurUseNoNm(result.FUN_PUR_USE_NO_NM);
		setMiddCorpPermYn(result.MIDD_CORP_PERM_YN =="Y"?"예":"아니오");
		setDonReceIssContCd(result.DON_RECE_ISS_CONT_CD);
		setBizMainMangUserid(result.BIZ_MAIN_MANG_USERID);
		setBizMainMangUserNm(result.BIZ_MAIN_MANG_USER_NM);
		setBizDeptMangUserid(result.BIZ_DEPT_MANG_USERID);
		setBizDeptMangUserNm(result.BIZ_DEPT_MANG_USER_NM);
		setNotes(result.NOTES);
		setDonReceIssKey(result.DON_RECE_ISS_KEY);
		setRegUserNm(result.REG_USER_NM);
		setRegUserId(result.REG_USERID);
		setRegDate(dateToStr(result.REG_DATE));
		
	};

	//상세정보 값 가지고 오기
	function getInfo(name){
		if(Object.keys(bizInfo).length != 0){
			return bizInfo[name];
		}else{
			return '';
		}
	};


	//삭제 
	async function bizInfoDelete (){
		if(await UIUtils.confirm(message.get("common.message.delete.confirm", "정말로 삭제하시겠습니까?"))){
			let param = {
				"BIZ_CD": bizCd
			};

			const response:any = await CommonUtil.execute({
				url:'adm_6311_bizDelete',
				data: param
			})
			
			let dataToSend = {};
			// 다른 페이지로 이동하면서 데이터 전달
			history.push({
			pathname: './adm6310',
			state: { data: receivedData }
			});
		}
	}

	//수정 페이지로 이동
	const bizInfoUpdate = function (){
        let dataToSend = {};
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
		pathname: './adm6314',
		state: { data: receivedData }
		});
	}

	//목록으로 
	const goList = () =>{
		history.push({
			pathname: './adm6310',  
			state: { data: receivedData }
		});
	}

	React.useEffect(() => {
		//필요한 공통코드 로딩.
		codeDataStore.read("/common/yesNoYN",
        "[FPUC]",
        "[FPUN]").then(() => {
			setLoadFinish(true);

			 //넘어온 파라미터 바인딩   
			if(receivedData != undefined){
				let bizCd = StringUtil.defaultString(receivedData.vBIZ_CD);
				setBizCd(bizCd)
				localStorage.setItem("bizCd", bizCd);
			}
			
			let bizCdStorage = localStorage.getItem("bizCd");
			if (bizCdStorage != null) {
				setBizCd(bizCdStorage);
			}
			
			//상세데이터 가지고 오기
			initCall(bizCdStorage);

		});

	}, [])//effect


	if(!loadFinish)
		return (
			<PageLoading />
		)
	else
	
	return (
		<PageContainer>
			<LayoutAside />
				<div className="fww-con">

					<ul className="fww-brd">
						<li className=""><a href="">홈</a></li>
						<li className=""><a href="">관리자페이지</a></li>
						<li className=""><a href="">사용자관리</a></li>
						<li className=""><a href="">사업관리</a></li>
					</ul>

					<main className="fww-main">
						<h1 className="tx tx-hd2">사업 상세</h1>

						<form className="fo fo-col3 mb10" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">사업코드</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizCd} valueChanged={(value) => setBizCd(String(value))} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizNm} valueChanged={(value) => setBizNm(String(value))} readOnly={true} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업약칭</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizShortNm} valueChanged={(value) => setBizShortNm(String(value))} readOnly={true}/>
									</div>
								</div>							
								<div className="fo-item">
									<p className="fo-key">사업시작일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizStDate} valueChanged={(value) => setBizStDate(value)} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업종료일</p>
									<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={bisEnDate} valueChanged={(value) => setBizEnDate(value)} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">중견기업허용여부</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={middCorpPermYn} valueChanged={(value) => setMiddCorpPermYn(value)} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">기금사용용도</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={funPurUseCdNm} valueChanged={(value) => setFunPurUseCdNm(String(value))} readOnly={true}/>
										
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업분야</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={funPurUseNoNm} valueChanged={(value) => setFunPurUseNoNm(String(value))} readOnly={true}/>
									</div>
								</div>
																
								<div className="fo-item">
									<p className="fo-key">발급내역</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizShortNm} valueChanged={(value) => setBizShortNm(String(value))} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">주담당자</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8">
											<UIInput className={'tf tf-md w100p'}  value={bizMainMangUserNm} valueChanged={(value) => setBizMainMangUserNm(value)} readOnly={true}  />
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서장</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8">
											<UIInput className={'tf tf-md w100p'} value={bizDeptMangUserNm} valueChanged={(value) => setBizDeptMangUserNm(value)} readOnly={true}  />
										</div>
									</div>
								</div>
								
								<div className="fo-item req">
									<p className="fo-key">발행키</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={bizShortNm} valueChanged={(value) => setBizShortNm(String(value))} readOnly={true}/>
										
									</div>
								</div>
								
								<div className="fo-item">
									<p className="fo-key">비고사항</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={notes} valueChanged={(value) => setNotes(value)} readOnly={true}/>
									</div>
								</div>
								
								<div className="fo-item">
									<p className="fo-key">등록자</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={regUserNm} valueChanged={(value) => setRegUserNm(value)}  readOnly={true}/>
									</div>						
								</div>
								<div className="fo-item">
									<p className="fo-key">등록일시</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={regDate} valueChanged={(value) => setRegDate(value)} readOnly={true}/>
									</div>						
								</div>	
						

							</div> 
						</form>						

						<div className="hz-root hz-right hz-gap5">
							<Button color="gray-o" size="sm" onClick={bizInfoDelete}>삭제</Button>
							<Button color="pri-o" size="sm" onClick={bizInfoUpdate}>수정</Button>
							<Button color='gray-o' size="sm" onClick={goList}>목록</Button>
						</div>
						
					</main>

				</div>
		</PageContainer>
	);
}
export default ContentsContainer;